import { memo, useRef, useState } from 'react';
import { ReportContent, ReportHeader, ReportSearch } from '@/components/tableDrawer';
import BaseBtn from '@/components/tableDrawer/TableItems/components/tableActions/BaseBtn';
import { GetBrokerPatientsListGroups } from '@/api/endpoints/Broker/BrokerPatient';
import { DateValue } from '@/components/tableDrawer';
import { ColumnsGenerator } from '@/utils/tableUtils';
import UploadPatientSheet from './Components/Popups/UploadPatientSheet';
import ViewMedicalFiles from './Components/Popups/ViewMedicalFiles';
import { AttachmentsUploadedCell, CategoryRequestCell, NameRequestCell } from './Components/RowsData';
import './style.css';
import TableHeader from './Components/TableHeader';
import useNavs from '@/hooks/useNavs';
import { useSelectedTableItems } from '@/components/tableDrawer/reportContent/Hooks/useSelectedTableItems';

const PatientsListGroups = () => {

    const { BrokerNav } = useNavs();
    const { selectedItems, handleSelected } = useSelectedTableItems()

    const refModal = useRef(null)
    const refViewMedicalFilesModal = useRef(null)
    const [selectedPatientId, setSelectedPatientId] = useState(null)

    const columns = [
        ColumnsGenerator.SearchableTextCell('groupName'),
        ColumnsGenerator.HiddenSearchableText('patientName', 'patient'),
        ColumnsGenerator.CustomCell('patient-name',
            (original) => <NameRequestCell original={{ ...original, patientName: `${original.firstName} ${original.lastName}`, requestId: original.patientId }} />),
        ColumnsGenerator.TextCell('gender'),
        ColumnsGenerator.CustomCell('category', (original) => <CategoryRequestCell original={original} />),
        ColumnsGenerator.CustomCell('startDate', (original) => <DateValue value={original.startDate} />),
        ColumnsGenerator.CustomCell('endDate', (original) => <DateValue value={original.endDate} />),
        ColumnsGenerator.CustomCell('isAttachmentsUploaded', (original) => <AttachmentsUploadedCell original={original} />),

        ColumnsGenerator.CustomCell('action', (original) =>
            <>
                <BaseBtn onApply={() => viewRequestDetails(original)}
                    title="view-details"
                    className="details-info"
                    reqAction="canGet"
                    icon={"fluent:eye-16-filled"} />

                <BaseBtn onApply={() => viewMedicalFiles(original)}
                    title="view-medical-files"
                    className="medical-files-info"
                    reqAction="canGet"
                    icon={"mdi:file-document-multiple"} />
            </>
        )]

    const viewRequestDetails = (original) =>
        BrokerNav(`/clients/patientsListGroups/viewStats/${original?.id}/${original?.orderStatusId}`)

    const viewMedicalFiles = (original) => {
        setSelectedPatientId(original?.patientId)
        refViewMedicalFilesModal?.current?.click()
    }

    return (
        <>
            <TableHeader refModal={refModal} selectedItems={selectedItems} />

            <UploadPatientSheet refModal={refModal} />

            <ViewMedicalFiles refModal={refViewMedicalFilesModal} patientId={selectedPatientId} />

            <ReportContent needCheckbox handleSelected={handleSelected} tableAPI={GetBrokerPatientsListGroups} columns={columns}>
                <ReportHeader  >
                    <ReportSearch />
                </ReportHeader>
            </ReportContent>
        </>
    );
}

export default memo(PatientsListGroups);